import React from 'react';
import Layout from '../components/layout/Layout';
import { Badge } from '../components/ui/badge';
import { companyInfo } from '../data/mock';
import { FileText } from 'lucide-react';

const TerminosPage = () => {
  return (
    <Layout>
      <section className="py-20 lg:py-28">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <Badge className="mb-4 bg-emerald-100 text-emerald-700 hover:bg-emerald-100">
              <FileText className="h-3.5 w-3.5 mr-1.5" />
              Legal
            </Badge>
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Términos y Condiciones
            </h1>
            <p className="text-gray-600">
              Última actualización: Julio 2025
            </p>
          </div>

          <div className="prose prose-lg max-w-none">
            <h2>1. Aceptación de los Términos</h2>
            <p>
              Al acceder y utilizar los servicios de {companyInfo.name} (UPIM), usted acepta estar 
              sujeto a estos Términos y Condiciones. Si no está de acuerdo con alguno de estos términos, 
              le rogamos que no utilice nuestros servicios.
            </p>

            <h2>2. Descripción de los Servicios</h2>
            <p>UPIM ofrece los siguientes servicios a sus afiliados:</p>
            <ul>
              <li>Membresía a la asociación de profesionales inmobiliarios</li>
              <li>Acceso a capacitaciones, cursos y certificaciones</li>
              <li>Asesoría jurídica, financiera y contable</li>
              <li>Acceso a beneficios y descuentos con proveedores certificados</li>
              <li>Participación en eventos y networking</li>
              <li>Acceso a recursos y materiales exclusivos</li>
            </ul>

            <h2>3. Membresía y Afiliación</h2>
            <h3>3.1 Requisitos</h3>
            <p>
              Para ser afiliado de UPIM, el solicitante debe ser mayor de edad y dedicarse 
              profesionalmente al sector inmobiliario o actividades relacionadas.
            </p>
            
            <h3>3.2 Proceso de Afiliación</h3>
            <p>El proceso de afiliación incluye:</p>
            <ul>
              <li>Pago de la cuota de afiliación correspondiente</li>
              <li>Envío de documentación requerida</li>
              <li>Firma del Código de Ética de UPIM</li>
              <li>Aceptación del Manual de Afiliación</li>
            </ul>

            <h3>3.3 Vigencia</h3>
            <p>
              La membresía tiene una vigencia de 12 meses a partir de la fecha de pago. La renovación 
              debe realizarse antes del vencimiento para mantener los beneficios activos.
            </p>

            <h2>4. Pagos y Facturación</h2>
            <p>
              Todos los pagos deben realizarse a través de los medios autorizados por UPIM. Los precios 
              están sujetos a cambios previo aviso. Las cuotas de afiliación no son reembolsables.
            </p>

            <h2>5. Código de Conducta</h2>
            <p>Los afiliados de UPIM se comprometen a:</p>
            <ul>
              <li>Actuar con integridad y profesionalismo</li>
              <li>Respetar el Código de Ética de la asociación</li>
              <li>Mantener una conducta apropiada en eventos y comunicaciones</li>
              <li>No utilizar la marca UPIM de manera no autorizada</li>
              <li>Reportar cualquier irregularidad o práctica antiética</li>
            </ul>

            <h2>6. Propiedad Intelectual</h2>
            <p>
              Todo el contenido, materiales, logos, marcas y recursos proporcionados por UPIM son 
              propiedad exclusiva de la asociación. El uso no autorizado está estrictamente prohibido.
            </p>

            <h2>7. Limitación de Responsabilidad</h2>
            <p>
              UPIM no será responsable de daños indirectos, incidentales o consecuentes que surjan del 
              uso de nuestros servicios. Los servicios de terceros (proveedores certificados) son 
              responsabilidad de cada proveedor.
            </p>

            <h2>8. Suspensión y Cancelación</h2>
            <p>
              UPIM se reserva el derecho de suspender o cancelar la membresía de cualquier afiliado 
              que viole estos términos o el Código de Ética, sin derecho a reembolso.
            </p>

            <h2>9. Modificaciones</h2>
            <p>
              UPIM se reserva el derecho de modificar estos términos en cualquier momento. Las 
              modificaciones serán comunicadas a través de nuestros canales oficiales.
            </p>

            <h2>10. Ley Aplicable</h2>
            <p>
              Estos términos se rigen por las leyes de los Estados Unidos Mexicanos. Cualquier 
              controversia será resuelta en los tribunales competentes de la Ciudad de México.
            </p>

            <h2>11. Contacto</h2>
            <p>
              Para cualquier consulta sobre estos términos, contáctenos en:
            </p>
            <ul>
              <li>Email: {companyInfo.email}</li>
              <li>Teléfono: {companyInfo.phone}</li>
              <li>Dirección: {companyInfo.address}</li>
            </ul>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default TerminosPage;
